export default __webpack_public_path__ + "static/media/W5_1200G_front_alternativa.eeff74d8.png";